import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import API_BASE_URL from "../config";
import axios from "axios";

import {
  createCategoryThunk,
  updateCategoryThunk,
  fetchCategoriesThunk,
} from "./redux/categoryThunk";
import {
  setShowForm,
  setLinkForm,
  setEditingCategory,
} from "./redux/categorySlice";
import {
  fetchClassesThunk,
  fetchSubjectsByClassThunk,
} from "../chapter/redux/chapterThunk";

export default function TypeLink() {
  const dispatch = useDispatch();
  const { classes, subjects } = useSelector((state) => state.chapter);
  const [selectedSubjectIds, setSelectedSubjectIds] = useState([]);
  const [mappedSubjects, setMappedSubjects] = useState([]);

  const [typeName, setTypeName] = useState("");
  const [type_title, settype_title] = useState("");
  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");

  useEffect(() => {
    dispatch(fetchClassesThunk());
  }, [dispatch]);

  useEffect(() => {
    if (classId) dispatch(fetchSubjectsByClassThunk(classId));
  }, [classId, dispatch]);

  const { editingCategory } = useSelector((state) => state.category);
  console.log("Editing category:", editingCategory);

  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setSelectedSubjectIds((prev) => [...prev, id]);
    } else {
      setSelectedSubjectIds((prev) => prev.filter((sid) => sid !== id));
    }
  };

  const fetchMappedSubjects = async (typeId) => {

    try {
      const res = await axios.get(
        `${API_BASE_URL}/classes/get-mapped-type/${typeId}`
      );
      setMappedSubjects(res.data); // Assumes response is an array of mappings
    } catch (err) {
      console.error("Error fetching mapped subjects:", err);
      setMappedSubjects([]); // Fallback to empty array on error
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!classId || selectedSubjectIds.length === 0 || !editingCategory?.type_id) {
    alert("Please select class and at least one subject.");
    return;
  }

  const payload = {
    type_id: editingCategory.type_id,
    class_id: Number(classId),
    subject_ids: selectedSubjectIds,
  };

  try {
    const res = await axios.post(`${API_BASE_URL}/classes/create-mapping`, payload);
    alert("✅ Type linked to subjects successfully!");
    dispatch(setLinkForm(false));
    dispatch(setEditingCategory(null));
  } catch (err) {
    console.error("Error mapping type to subjects:", err);
    alert("❌ Failed to map subjects: " + (err?.response?.data?.error || err.message));
  }
};


  useEffect(() => {
    if (editingCategory) {
      setTypeName(editingCategory.type_name || "");
      settype_title(editingCategory.type_title || "");
      setClassId(
        editingCategory.class_id ? String(editingCategory.class_id) : ""
      );
      setSubjectId(
        editingCategory.subject_id ? String(editingCategory.subject_id) : ""
      );

      // Ensure subjects for that class are loaded
      if (editingCategory.class_id) {
        dispatch(fetchSubjectsByClassThunk(editingCategory.class_id));
      }
    } else {
      // If not editing (i.e., creating), clear fields
      setTypeName("");
      settype_title("");
      setClassId("");
      setSubjectId("");
    }
  }, [editingCategory, dispatch]);

  useEffect(() => {
    if (editingCategory?.type_id) {
      fetchMappedSubjects(editingCategory.type_id);
    }
  }, [editingCategory]);

  useEffect(() => {
    if (classId && mappedSubjects.length > 0) {
      const filtered = mappedSubjects.filter(
        (map) => map.class_id === Number(classId)
      );
      const subjectIds = filtered.map((m) => m.subject_id);
      setSelectedSubjectIds(subjectIds);
    } else {
      setSelectedSubjectIds([]); // Optional: clear if no mapping
    }
  }, [classId, mappedSubjects]);

  const handleCancel = () => {
    dispatch(setLinkForm(false));
    dispatch(setEditingCategory(null));
  };

  return (
    <form onSubmit={handleSubmit} style={{ padding: "20px" }}>
      <div style={{ marginBottom: "10px" }}>
        <label>Type Name: &nbsp;{typeName}</label>
      </div>

      <div style={{ marginBottom: "10px" }}>
        <label>Title:&nbsp;{type_title}</label>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <label>Select Class:</label>
        <select
          value={classId}
          onChange={(e) => setClassId(e.target.value)}
          style={{ width: "100%", padding: "5px" }}
        >
          <option value="">-- Select Class --</option>
          {classes.map((cls) => (
            <option key={cls.class_id} value={cls.class_id}>
              {cls.class_name}
            </option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: "10px" }}>
        <label>Select Subjects to link:</label>
        <div
          style={{
            maxHeight: "150px",
            overflowY: "auto",
            border: "1px solid #ccc",
            padding: "10px",
          }}
        >
          {subjects.map((sub) => (
            <div key={sub.subject_id}>
              <label>
                <input
                  type="checkbox"
                  value={sub.subject_id}
                  checked={selectedSubjectIds.includes(sub.subject_id)}
                  onChange={(e) => handleCheckboxChange(e, sub.subject_id)}
                />{" "}
                {sub.subject_name}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <button type="button" onClick={handleCancel}>
          Cancel
        </button>
        <button
          type="submit"
          style={{ background: "blue", color: "#fff", padding: "5px 10px" }}
        >
          Save
        </button>
      </div>
    </form>
  );
}
